var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleSheet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.807 12.8v2.4H22.38v-2.4H9.807zM9.807 19.2v-2.4h3.143v2.4H9.807zM9.807 20.8v2.4h3.143v-2.4H9.807zM14.52 20.8v2.4h3.142v-2.4H14.52zM19.232 20.8v2.4h3.142v-2.4h-3.142zM19.232 19.2v-2.4h3.142v2.4h-3.142zM17.662 19.2H14.52v-2.4h3.143v2.4z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.805 0H5.877a.779.779 0 00-.556.234.807.807 0 00-.23.566v30.4c0 .212.083.416.23.566.147.15.347.234.556.234h20.428a.779.779 0 00.556-.234.807.807 0 00.23-.566V6.4h-5.5a.779.779 0 01-.556-.234.807.807 0 01-.23-.566V0zM8.234 12c0-.212.083-.416.23-.566a.779.779 0 01.556-.234h14.142c.209 0 .409.084.556.234.147.15.23.354.23.566v12a.808.808 0 01-.23.566.779.779 0 01-.556.234H9.02a.779.779 0 01-.556-.234.807.807 0 01-.23-.566V12z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.634 4.8H22.38V.468L26.634 4.8z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/google-sheet.947206b26d718100e7d2a67dd0c61b03.svg";
export { SvgGoogleSheet as ReactComponent };